export class CourseSearchStudentResult {
  id: number;
  studentId: string;
  bookingUrl: string;
  priceLink: string;
  canEnrol: boolean;
}
